import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  submitCorporateAndOrgStructureFailure,
  submitCorporateAndOrgStructureRequest,
} from "../../../../store/features/actions/corporateAndOrgStructureActions";
import {
  getAllSubdimensionMatches,
  getAllPageInsights,
} from "../../../../services/commonService";
import "./MarketingDistribution.css";
import AdvertisingMediaSpend from "./AdvertisingMediaSpend";
import MessagingPositioning from "./MessagingPositioning";
import DigitalFootprintAnalysis from "./DigitalFootprintAnalysis";
import PricingModelsBundling from "./PricingModelsBundling";
import DistributionModel from "./DistributionModel";
import TopRightActionLinks from "../TopRightActionLinks";
import InsightBlock from "../InsightBlock";
import GenericOverviewSideCard from "../../genericComponents/GenericOverviewSideCard";
import AIChat from "../../Chat/AiChat";
import GenericTableSkeleton from "../../skeletons/tableSkeleton/genericTableSkeleton";

function MarketingDistribution() {
  const { clientName, competitorName } = useParams();
  const [pagePositives, setPagePositives] = useState([]);
  const [pageNegatives, setPageNegatives] = useState([]);
  const [pageSoWhat, setPageSoWhat] = useState([]);
  const [advertisingAndMediaSpend, setAms] = useState([]);
  const [messagingAndPositioning, setMessagingAndPositioning] = useState([]);
  const [digitalFootprintAnalysis, setDigitalFootprintAnalysis] = useState([]);
  const [pricingModelsAndBundling, setPricingModelsAndBundling] = useState([]);
  const [distributionModel, setDistributionModel] = useState([]);
  const [showConversationModal, setShowConversationModal] = useState(false);
  const dispatch = useDispatch();

  const { loading, data, error } = useSelector(
    (state) => state.corporateAndOrgStructureReducer
  );

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    dispatch(submitCorporateAndOrgStructureRequest("Marketing & Distribution", clientName));
  }, []);

  useEffect(() => {
    const tempAms = getAllSubdimensionMatches(
      data,
      "Advertising & Media Spend"
    );
    setAms(tempAms);

    const tempMessagingAndPositioning = getAllSubdimensionMatches(
      data,
      "Messaging & Positioning"
    );
    setMessagingAndPositioning(tempMessagingAndPositioning);

    const tempDigitalFootprintAnalysis = getAllSubdimensionMatches(
      data,
      "Digital Footprint Analysis"
    );
    setDigitalFootprintAnalysis(tempDigitalFootprintAnalysis);

    const tempPricingModelsAndBundling = getAllSubdimensionMatches(
      data,
      "Pricing Models & Bundling"
    );
    setPricingModelsAndBundling(tempPricingModelsAndBundling);

    const tempDistributionModel = getAllSubdimensionMatches(
      data,
      "Distribution Model"
    );
    setDistributionModel(tempDistributionModel);

    const { positive, negative, sowhat } = getAllPageInsights(data);
    setPagePositives(positive || []);
    setPageNegatives(negative || []);
    setPageSoWhat(sowhat || []);
  }, [data]);
  const handleAiConversation = () => console.log("AI conversation clicked");
  const handleDownload = () => console.log("Download clicked");

  const actions = [
    {
      type: "conversation",
      title: "Conversation",
      onClick: () => {
        setShowConversationModal((prev) => !prev);
      },
    },
    { type: "download", title: "Download", onClick: handleDownload },
  ];

  return (
    <div>
      <div className="marketing_distrubution_wrapper">
        {loading ? (
          <GenericTableSkeleton colCount={3} rowCount={5} />
        ) : (
          <InsightBlock
            title={"Marketing & Distribution"}
            overview={
              "Comparative analysis of messaging, media spend, digital presence, pricing, and go-to-market distribution strategies across top healthcare suppliers."
            }
            actions={actions}
            pagePositives={pagePositives}
            pageNegatives={pageNegatives}
            pageSoWhat={pageSoWhat}
          />
        )}

        {loading ? (
          <GenericTableSkeleton colCount={3} rowCount={5} />
        ) : (
          <AdvertisingMediaSpend
            advertisingAndMediaSpend={advertisingAndMediaSpend}
          />
        )}

        {loading ? (
          <GenericTableSkeleton colCount={3} rowCount={5} />
        ) : (
          <MessagingPositioning
            messagingAndPositioning={messagingAndPositioning}
          />
        )}

        {loading ? (
          <GenericTableSkeleton colCount={3} rowCount={5} />
        ) : (
          <DigitalFootprintAnalysis
            digitalFootprintAnalysis={digitalFootprintAnalysis}
          />
        )}

        {loading ? (
          <GenericTableSkeleton colCount={3} rowCount={5} />
        ) : (
          <PricingModelsBundling
            pricingModelsAndBundling={pricingModelsAndBundling}
          />
        )}

        {loading ? (
          <GenericTableSkeleton colCount={3} rowCount={5} />
        ) : (
          <DistributionModel distributionModel={distributionModel} />
        )}
      </div>
      {showConversationModal && (
        <GenericOverviewSideCard
          showMoreModal={showConversationModal}
          setShowMoreModal={setShowConversationModal}
          titleForSideCard={
            <div className="ai_insight_top_block">
              <div className="ai_insight_left">
                <div className="ai_insight_img">
                  <img
                    src="/img/ai_insight_top.png"
                    alt="icon"
                    className="ai_icon"
                  />
                </div>
                <div className="ai_insight_text">
                  <h5 className="ai_insight_top_head">
                    Decode This:{" "}
                    {competitorName ?? "Tailored Chemical Products"} - Market
                    Insights
                  </h5>
                  <p className="ai_insight_top_subhead">
                    AI-powered competitive intelligence and strategic insights
                  </p>
                </div>
              </div>
              <div className="ai_insight_right"></div>
            </div>
          }
          comp={<AIChat section={"Marketing & Distribution"} />}
          minWidthForDrawer="40%"
          disableXbtn={false}
        />
      )}
    </div>
  );
}

export default MarketingDistribution;
